<template>
  <div class="search-result">
    <section class="container search-content">
      <SearchBar v-model="value" @search="searchHandler"></SearchBar>
      <div class="shop-cart-box">
        <ShopCardIcon :value="0" />
      </div>
    </section>
    <section class="container">
      <TablePage ref="list" @page-change="pageHandler" :total="total" :pageSizeNum="12">
        <div class="total-result">共{{ total }}条结果 {{ total }} results</div>
        <div class="good-list-container act-ctn">
          <GoodsPanel
            class="activity-item"
            v-for="item in goodsList"
            :coverImage="item.coverImage"
            :price="item.price"
            :oprice="item.oprice"
            :spuName="item.spuName"
            :spuNameEn="item.spuNameEn"
            :key="item.id"
            :id="item.id"
            @handleTarget="handleTarget"
          >
          </GoodsPanel>
        </div>
      </TablePage>
    </section>
  </div>
</template>

<script>
import GoodsPanel from "@/components/base/GoodsPanel";
import TablePage from "@/components/base/TablePage";
import SearchBar from "@/components/base/SearchBar";
import ShopCardIcon from "@/components/base/ShopCardIcon.vue";
import moment from "moment";
export default {
  name: "",
  components: { GoodsPanel, TablePage, SearchBar, ShopCardIcon },
  data() {
    return {
      goodsList: [], //商品列表
      total: 0,
      value: "", //搜索关键词
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.value = this.$route.query.value ?? "";
    this.searchHandler();
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },

    //跳转
    handleTarget(id) {
      this.$router.push(`/e-shop/good-info?id=${id}`);
    },

    //获取商品列表
    async pageHandler(page, pageSize) {
      const params = {
        sceneMarketSwitch: 1,
        page: page,
        pageSize: pageSize,
        spuName: this.value,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getGoodsList(params);
        this.goodsList = list.map((item) => {
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    groupId(val) {
      this.searchHandler();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-content {
  margin-top: 60px;
  margin-bottom: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.e-shop-title {
  margin: 159px 0 99px;
}
.act-ctn {
  display: flex;
  flex-wrap: wrap;
}
.activity-item {
  margin-right: 30px;
  margin-bottom: 30px;
  width: 380px;
  &.activity-item:nth-child(3n) {
    margin-right: 0;
  }
  .desc-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-left {
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
    }
    .content-icon {
      width: 21px;
      height: 21px;
      margin-right: 11px;
    }
  }
}
.channel-nav-container {
  margin-bottom: 60px;
  margin-top: 160px;
}
.good-list-container {
  display: flex;
  flex-wrap: wrap;
}
.total-result {
  font-size: 14px;
  color: #999999;
  margin-bottom: 30px;
}
</style>
